import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileBottomBar from "@/components/MobileBottomBar";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ServicesOverview from "@/pages/ServicesOverview";
import ServicePage from "@/pages/ServicePage";
import HivPep from "@/pages/HivPep";
import Symptoms from "@/pages/Symptoms";
import Testing from "@/pages/Testing";
import OnlineConsultation from "@/pages/OnlineConsultation";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import Booking from "@/pages/Booking";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

const LenisProvider = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothTouch: false });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return children;
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <LenisProvider>
          <ScrollToTop />
          <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1 pb-20 md:pb-0">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about-dr-ankur-lal" element={<About />} />
                <Route path="/std-sti-treatment" element={<ServicesOverview />} />
                <Route path="/services/:slug" element={<ServicePage />} />
                <Route path="/hiv-pep-delhi" element={<HivPep />} />
                <Route path="/std-symptoms" element={<Symptoms />} />
                <Route path="/std-hiv-testing" element={<Testing />} />
                <Route path="/online-consultation" element={<OnlineConsultation />} />
                <Route path="/privacy-confidentiality" element={<Privacy />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/booking" element={<Booking />} />
                <Route path="/privacy-policy" element={<Legal />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <MobileBottomBar />
            <Toaster position="top-center" richColors />
          </div>
        </LenisProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
